module.exports = __webpack_public_path__ + "img/Skills.b06b43bd.svg";